<template>
  <ElDialog
    class="modal"
    :visible.sync="showModal"
    :width="modalWidth">
    <h2 class="modal__title">
      Оформить новый договор
    </h2>
    <div class="modal__body">
      <p class="modal__text">
        {{ text }} <br>Просим скорректировать или удалить, либо оформить новый договор
      </p>
    </div>
    <div class="modal__submit-buttons">
      <BaseButton text="Оформить новый договор"
                  size="large"
                  @click.native="prolong"/>
      <BaseButton text="Скорректировать"
                  size="large"
                  type="secondary"
                  plain
                  @click.native="closeModal"/>
    </div>
  </ElDialog>
</template>

<script>
import modal from "@/mixins/modal";
import BaseButton from '@/components/ui/BaseButton';

export default {
  name: 'ModalPolicyIssuanceProlong',
  components: {
    BaseButton
  },
  mixins: [modal],
  props: {
    text: {
      type: String,
      default: 'Номер предыдущего договора некорректен'
    }
  },
  methods: {
    prolong() {
      this.$emit('prolong');
    }
  },
}
</script>
